
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/duaa",
      function () {
        return require("private-next-pages/duaa/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/duaa"])
      });
    }
  